import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-geodata',
  templateUrl: './geodata.component.html',
  styleUrl: './geodata.component.scss',
  imports: [
    RouterModule,
    MatListModule,
    MatTableModule,
    MatIconModule,
  ],
})
export class GeodataComponent {
  readonly services = [
    {
      title: {
        value: "NP_Basiskart_Svalbard_WMTS_25833",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_Svalbard_WMTS_25833/MapServer?f=jsapi",
      },
      layers: "Svalbard Topography",
      projection: "WGS 84 UTM zone 33N (EPSG:25833)",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_Svalbard_WMTS_25833/MapServer",
      },
      capabilities: {
        value: "WMTS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_Svalbard_WMTS_25833/MapServer/WMTS/1.0.0/WMTSCapabilities.xml",
      },
    },
    {
      title: {
        value: "NP_Basiskart_Svalbard_WMTS_3857",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_Svalbard_WMTS_3857/MapServer?f=jsapi",
      },
      layers: "Svalbard Topography",
      projection: "WGS 84 Pseudo-Mercator (EPSG:3857)",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_Svalbard_WMTS_3857/MapServer",
      },
      capabilities: {
        value: "WMTS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_Svalbard_WMTS_3857/MapServer/WMTS/1.0.0/WMTSCapabilities.xml",
      },
    },
    {
      title: {
        value: "NP_Ortofoto_Svalbard_WMTS_25833",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Ortofoto_Svalbard_WMTS_25833/MapServer?f=jsapi"
      },
      layers: "Svalbard Orthophoto",
      projection: "ETRS 89 UTM 33 (EPSG:25833)",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Ortofoto_Svalbard_WMTS_25833/MapServer"
      },
      capabilities: {
        value: "WMTS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Ortofoto_Svalbard_WMTS_25833/MapServer/WMTS/1.0.0/WMTSCapabilities.xml"
      }
    },
    {
      title: {
        value: "NP_Ortofoto_Svalbard_WMTS_3857",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Ortofoto_Svalbard_WMTS_3857/MapServer?f=jsapi"
      },
      layers: "Svalbard Orthophoto",
      projection: "WGS 84 Pseudo-Mercator (EPSG:3857)",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Ortofoto_Svalbard_WMTS_3857/MapServer"
      },
      capabilities: {
        value: "WMTS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Ortofoto_Svalbard_WMTS_3857/MapServer/WMTS/1.0.0/WMTSCapabilities.xml"
      }
    },
    {
      title: {
        value: "NP_Satellitt_Svalbard_WMTS_25833",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Satellitt_Svalbard_WMTS_25833/MapServer?f=jsapi"
      },
      layers: "Svalbard Satellite Imagery",
      projection: "ETRS 89 UTM 33 (EPSG:25833)",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Satellitt_Svalbard_WMTS_25833/MapServer"
      },
      capabilities: {
        value: "WMTS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Satellitt_Svalbard_WMTS_25833/MapServer/WMTS/1.0.0/WMTSCapabilities.xml"
      }
    },
    {
      title: {
        value: "NP_Satellitt_Svalbard_WMTS_3857",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Satellitt_Svalbard_WMTS_3857/MapServer?f=jsapi"
      },
      layers: "Svalbard Satellite Imagery",
      projection: "WGS 84 Pseudo-Mercator (EPSG:3857)",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Satellitt_Svalbard_WMTS_3857/MapServer"
      },
      capabilities: {
        value: "WMTS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Satellitt_Svalbard_WMTS_3857/MapServer/WMTS/1.0.0/WMTSCapabilities.xml"
      }
    },
    {
      title: {
        value: "FKB_Svalbard_WMTS_25833",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/FKB_Svalbard_WMTS_25833/MapServer?f=jsapi"
      },
      layers: "Detailed map for the Svalbard settlements",
      projection: "ETRS 89 UTM 33 (EPSG:25833)",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/FKB_Svalbard_WMTS_25833/MapServer"
      },
      capabilities: {
        value: "WMTS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/FKB_Svalbard_WMTS_25833/MapServer/WMTS/1.0.0/WMTSCapabilities.xml"
      }
    },
    {
      title: {
        value: "FKB_Svalbard_WMTS_3857",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/FKB_Svalbard_WMTS_3857/MapServer?f=jsapi"
      },
      layers: "Detailed map for the Svalbard settlements",
      projection: "WGS 84 Pseudo-Mercator (EPSG:3857)",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/FKB_Svalbard_WMTS_3857/MapServer"
      },
      capabilities: {
        value: "WMTS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/FKB_Svalbard_WMTS_3857/MapServer/WMTS/1.0.0/WMTSCapabilities.xml"
      }
    },
    {
      title: {
        value: "NP_Basiskart_JanMayen_WMTS_25829",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_JanMayen_WMTS_25829/MapServer?f=jsapi"
      },
      layers: "Jan Mayen Topography",
      projection: "ETRS 89 UTM 29 (EPSG:25829)",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_JanMayen_WMTS_25829/MapServer"
      },
      capabilities: {
        value: "WMTS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_JanMayen_WMTS_25829/MapServer/WMTS/1.0.0/WMTSCapabilities.xml"
      }
    },
    {
      title: {
        value: "NP_Basiskart_JanMayen_WMTS_25833",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_JanMayen_WMTS_25833/MapServer?f=jsapi"
      },
      layers: "Jan Mayen Topography",
      projection: "ETRS 89 UTM 33 (EPSG:25833)",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_JanMayen_WMTS_25833/MapServer"
      },
      capabilities: {
        value: "WMTS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_JanMayen_WMTS_25833/MapServer/WMTS/1.0.0/WMTSCapabilities.xml"
      }
    },
    {
      title: {
        value: "NP_Basiskart_JanMayen_WMTS_3857",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_JanMayen_WMTS_3857/MapServer?f=jsapi"
      },
      layers: "Jan Mayen Topography",
      projection: "WGS 84 Pseudo-Mercator (EPSG:3857)",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_JanMayen_WMTS_3857/MapServer"
      },
      capabilities: {
        value: "WMTS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_JanMayen_WMTS_3857/MapServer/WMTS/1.0.0/WMTSCapabilities.xml"
      }
    },
    {
      title: {
        value: "NP_Satellitt_JanMayen_WMTS_25829",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Satellitt_JanMayen_WMTS_25829/MapServer?f=jsapi"
      },
      layers: "Jan Mayen Satellite Imagery",
      projection: "ETRS 89 UTM 29 (EPSG:25829)",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Satellitt_JanMayen_WMTS_25829/MapServer"
      },
      capabilities: {
        value: "WMTS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Satellitt_JanMayen_WMTS_25829/MapServer/WMTS/1.0.0/WMTSCapabilities.xml"
      }
    },
    {
      isDynamic: true,
      title: {
        value: "NP_Basiskart_Svalbard_WMS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_Svalbard_WMS/MapServer?f=jsapi"
      },
      layers: "Svalbard topography",
      projection: "",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_Svalbard_WMS/MapServer"
      },
      capabilities: {
        value: "WMS",
        url: "https://geodata.npolar.no/arcgis/services/Basisdata/NP_Basiskart_Svalbard_WMS/MapServer/WMSServer?request=GetCapabilities&amp;service=WMS"
      }
    },
    {
      isDynamic: true,
      title: {
        value: "NP_Basiskart_JanMayen_WMS",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_JanMayen_WMS/MapServer?f=jsapi"
      },
      layers: "Jan Mayen topography",
      projection: "",
      service: {
        value: "ArcGIS Rest",
        url: "https://geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Basiskart_JanMayen_WMS/MapServer"
      },
      capabilities: {
        value: "WMS",
        url: "https://geodata.npolar.no/arcgis/services/Basisdata/NP_Basiskart_JanMayen_WMS/MapServer/WMSServer?request=GetCapabilities&amp;service=WMS"
      }
    },
  ];

  readonly scales = [
    { zoomLevel: "0", scale: "1:81 920 000", resolution: 21674.7100160867 },
    { zoomLevel: "1", scale: "1:40 960 000", resolution: 10837.3550080434 },
    { zoomLevel: "2", scale: "1:20 480 000", resolution: 5418.67750402168 },
    { zoomLevel: "3", scale: "1:10 240 000", resolution: 2709.33875201084 },
    { zoomLevel: "4", scale: "1:5 120 000", resolution: 1354.66937600542 },
    { zoomLevel: "5", scale: "1:2 560 000", resolution: 677.334688002709 },
    { zoomLevel: "6", scale: "1:1 280 000", resolution: 338.667344001355 },
    { zoomLevel: "7", scale: "1:640 000", resolution: 169.333672000677 },
    { zoomLevel: "8", scale: "1:320 000", resolution: 84.6668360003387 },
    { zoomLevel: "9", scale: "1:160 000", resolution: 42.3334180001693 },
    { zoomLevel: "10", scale: "1:80 000", resolution: 21.1667090000847 },
    { zoomLevel: "11", scale: "1:40 000", resolution: 10.5833545000423 },
    { zoomLevel: "12", scale: "1:20 000", resolution: 5.29167725002117 },
    { zoomLevel: "13", scale: "1:10 000", resolution: 2.64583862501058 },
    { zoomLevel: "14 (orthophoto)", scale: "1:5 000", resolution: 1.3229193125052918 },
    { zoomLevel: "15 (orthophoto)", scale: "1:2 500", resolution: 0.6614596562526459 },
    { zoomLevel: "16 (orthophoto)", scale: "1:1 250", resolution: 0.33072982812632296 },
    { zoomLevel: "17 (orthophoto)", scale: "1:625", resolution: 0.16536491406316148 }
  ];

  readonly thematicServices = [
    {
      category: "Fauna og flora Svalbard",
      title: {
        value: "Sjøfuglkolonier",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data:seabirds_colonies_species&styles=&format=application/openlayers"
      },
      description: "Seabirds of Svalbard",
      owner: "Norwegian Polar Institute"
    },
    {
      category: "Fauna og flora Svalbard",
      title: {
        value: "Sjøpattedyr",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Amarine_mammals&bbox=346331.375%2C8212038.0%2C1104712.75%2C9052894.0&width=692&height=768&srs=EPSG%3A25833&styles=&format=application/openlayers"
      },
      description: "Marine Mammals in Svalbard",
      owner: "Norwegian Polar Institute"
    },
    {
      category: "Fauna og flora Svalbard",
      title: {
        value: "Vegetasjon",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Avegetations_classes&bbox=398580.0%2C8495405.0%2C827220.0%2C8980685.0&width=678&height=768&srs=EPSG%3A32633&styles=&format=application/openlayers"
      },
      description: "Svalbard Vegetation",
      owner: "Norwegian Polar Institute"
    },
    {
      category: "Fauna og flora Svalbard",
      title: {
        value: "Biogeografiske",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Abiogeographic_zones&bbox=402204.71875%2C8253539.0%2C845943.9375%2C8978518.0&width=470&height=768&srs=EPSG%3A25833&styles=&format=application/openlayers"
      },
      description: "Biogeographic zones of Svalbard",
      owner: "Norwegian Polar Institute"
    },
    {
      category: "Fauna og flora Svalbard",
      title: {
        value: "Reinbestandsområder",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Areindeer_population_areas&bbox=402222.21875%2C8487540.0%2C824517.0625%2C8978521.0&width=660&height=768&srs=EPSG%3A25833&styles=&format=application/openlayers"
      },
      description: "Reindeer population areas",
      owner: "Norwegian Polar Institute"
    },
    {
      category: "Ferdsel Svalbard",
      title: {
        value: "Ilandstigningslokaliteter",
        url: "https://kart2.miljodirektoratet.no/arcgis/rest/services/svalbard/ilandstigningslokaliteter_svalbard/MapServer"
      },
      description: "Boat landing sites",
      owner: "Miljødirektoratet"
    },
    {
      category: "Ferdsel Svalbard",
      title: {
        value: "Fartsrestriksjoner",
        url: "https://kart2.miljodirektoratet.no/arcgis/rest/services/svalbard/motorferdsel_svalbard/MapServer/0"
      },
      description: "Traffic regulations",
      owner: "Miljødirektoratet"
    },
    {
      category: "Ferdsel Svalbard",
      title: {
        value: "Ferdselsregler",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Atravel_rules&bbox=269387.6943774796%2C5138491.809334871%2C731380.9792889762%2C9330126.130139956&width=330&height=768&srs=EPSG%3A25833&styles=&format=application/openlayers"
      },
      description: "Access regulations",
      owner: "Governor of Svalbard"
    },
    {
      category: "Geologi Svalbards",
      title: {
        value: "Geologi Svalbard S250 og S750",
        url: "https://geodata.npolar.no/arcgis/rest/services/Temadata/G_Geologi_Svalbard_S250_S750/MapServer"
      },
      description: "Geological Map of Svalbard 1:250000 and 1:750000",
      owner: "Norwegian Polar Institute"
    },
    {
      category: "Geologi Svalbards",
      title: {
        value: "Geologi Svalbard Raster",
        url: "https://geodata.npolar.no/arcgis/rest/services/Temadata/G_Geologi_Svalbard_Raster/MapServer"
      },
      description: "Geological Map of Svalbard Raster Image",
      owner: "Norwegian Polar Institute"
    },
    {
      category: "Geologi Svalbards",
      title: {
        value: "Geologi DML (Dronning Maud Land)",
        url: "https://geodata.npolar.no/arcgis/rest/services/Temadata/G_Geologi_DML/MapServer"
      },
      description: "Geological Map of Dronning Maud Land in Antarctica",
      owner: "Norwegian Polar Institute"
    },
    {
      category: "Havis og breer Svalbard",
      title: {
        value: "Havis - Frekvens forekomst siste 30 år",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Aseaice_frequency_30_year_isolines&bbox=-4664416.5%2C-3839493.25%2C4924043.5%2C4265000.0&width=768&height=649&srs=EPSG%3A6931&styles=&format=application/openlayers"
      },
      description: "Sea ice - Occurence frequencies past 30 years",
      owner: "Norwegian Polar Institute"
    },
    {
      category: "Havis og breer Svalbard",
      title: {
        value: "Havis - Historiske isgrenser (1550-1917)",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Aseaice_historic&bbox=-301750.625%2C7543684.0%2C2049554.375%2C9350498.0&width=768&height=590&srs=EPSG%3A25833&styles=&format=application/openlayers"
      },
      description: "Sea ice - HIstoric ice edga maps (1550 - 1917)",
      owner: "Norwegian Polar Institute"
    },
    {
      category: "Havis og breer Svalbard",
      title: {
        value: "Isbreer - Utstrekning (1936-2010)",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Aglacier_extents&bbox=407025.1875%2C8502331.0%2C845635.3125%2C8968083.0&width=723&height=768&srs=EPSG%3A32633&styles=&format=application/openlayers"
      },
      description: "Svalbard Glacier Area Outlines",
      owner: "Norwegian Polar Institute"
    },
    {
      category: "Naturmiljø Svalbard",
      title: {
        value: "RAMSAR-områder",
        url: "https://kart.miljodirektoratet.no/arcgis/rest/services/ramsar/MapServer"
      },
      description: "RAMSAR areas",
      owner: "Miljødirektoratet"
    },
    {
      category: "Naturmiljø Svalbard",
      title: {
        value: "Naturvernområder",
        url: "https://kart.miljodirektoratet.no/arcgis/rest/services/vern/MapServer/1"
      },
      description: "Nature reserves",
      owner: "Miljødirektoratet"
    },
    {
      category: "Naturmiljø Svalbard",
      title: {
        value: "PRIMOS - Sårbarhet for oljesøl",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Aprimos&bbox=334634.875613795%2C8230299.366107438%2C1023738.6753463987%2C9020175.032830978&width=670&height=768&srs=EPSG%3A25833&styles=&format=application/openlayers"
      },
      description: "PRIMOS - Areas vulnerable to oil spill",
      owner: "Norwegian Polar Institute"
    },
    {
      category: "Naturmiljø Svalbard",
      title: {
        value: "Strandrydding",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Abeach_cleanup_line&bbox=415210.25%2C8684752.0%2C456974.1875%2C8849261.0&width=330&height=768&srs=EPSG%3A25833&styles=&format=application/openlayers"
      },
      description: "Beach cleanup activities in Svalbard",
      owner: "Governor of Svalbard"
    },
    {
      category: "Samfunn Svalbard",
      title: {
        value: "Bosetninger",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Asettlements&bbox=434128.625%2C8272258.5%2C759530.3125%2C8845813.0&width=435&height=768&srs=EPSG%3A25833&styles=&format=application/openlayers"
      },
      description: "Populated places",
      owner: "Norwegian Polar Institute"
    },
    {
      category: "Samfunn Svalbard",
      title: {
        value: "Skyte- og jaktforbudssoner",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Ahunting_regulations&bbox=269387.6943774796%2C5138491.809334871%2C731380.9792889762%2C9330126.130139956&width=330&height=768&srs=EPSG%3A25833&styles=&format=application/openlayers"
      },
      description: "Hunting restrictions",
      owner: "Governor of Svalbard"
    },
    {
      category: "Samfunn Svalbard",
      title: {
        value: "Arealplanområder",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Aland_use_plan_areas&bbox=429741.4375%2C8661601.0%2C536740.0%2C8765875.0&width=768&height=748&srs=EPSG%3A25833&styles=&format=application/openlayers"
      },
      description: "Planning areas",
      owner: ""
    },
    {
      category: "Samfunn Svalbard",
      title: {
        value: "Sjøgrenser Svalbard",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Asea_borders&bbox=56855.80078125%2C8014524.5%2C1328878.0%2C9348795.0&width=732&height=768&srs=EPSG%3A25833&styles=&format=application/openlayers"
      },
      description: "Svalbard sea borders",
      owner: "Governor of Svalbard"
    },
    {
      category: "Samfunn Svalbard",
      title: {
        value: "Prøveboring etter olje",
        url: "https://app.npolar.no/geoserver/thematic-data/wms?service=WMS&version=1.1.0&request=GetMap&layers=thematic-data%3Atest_drilling_oil&bbox=422846.0%2C8507622.0%2C767646.0%2C8766726.0&width=768&height=577&srs=EPSG%3A25833&styles=&format=application/openlayers"
      },
      description: "Exploratory oil drilling sites",
      owner: ""
    }
  ];
}
